import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import "./SelectSiteModal.scss";

import { utilService } from "../../../../services/utilService";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: ([]) => void;
  listData: [];
}
const SelectSite: React.FC<ContainerProps> = (props) => {
  var [addScheduleListData, setAddScheduleListData]: any = useState([]);
  var [newAddScheduleList, setNewAddScheduleList] = useState<any>([]);
  var [selectScheduleListData, setSelectScheduleListData]: any = useState([]);
  var [initialOwnGroup, setInitialOwnGroup]: any = useState([]);
  var [isAllSchedulesSelected, setIsAllSchedulesSelected] = useState(false);
  var [isAnySchedulesSelected, setIsAnySchedulesSelected] = useState(false);
  var [finalList, setFinalSiteList] = useState([]);
  const { t } = useTranslation("ems");  

  useEffect(() => {
    if (newAddScheduleList && newAddScheduleList.length === 0) {
      setNewAddScheduleList(addScheduleListData);
    }
  }, [addScheduleListData]);

  useEffect(() => {
    //   fetchSelectScheduleList(paramsSelect);
    // selectOrUnselectAllSchedules(true, props.listData);
  }, [props.listData]);

  const onSubmit = () => {
    const finalList = addFinalscheduleListData();
    const params: any = getSubmitParams(finalList);
    setFinalSiteList(finalList);
    setSelectScheduleListData(finalList);
    props.onOk(finalList);
  };

  // // to enable/disable ok button and check/uncheck "All" checkbox
  const toggleSubmitButton = () => {
    const isAllSchedulesSelected = props.listData.every(
      (item: any) => item.isSelected === true
    );
    const isAnyScheduleSelected = props.listData.some(
      (item: any) => item.isSelected === true
    );
    if (isAllSchedulesSelected) {
      setIsAllSchedulesSelected(true);
      setIsAnySchedulesSelected(true);
    } else {
      setIsAllSchedulesSelected(false);
    }
    if (!isAnyScheduleSelected) {
      setIsAnySchedulesSelected(false);
    }
  };

  // functionality of "All" checkbox
  const selectOrUnselectAllSchedules = (
    checked: boolean,
    selectScheduleArray: any
  ) => {
    const selectedAllArray: any = [];
    props.listData.map((item: any) => {
      if (checked) {
        item.isSelected = true;
        setIsAnySchedulesSelected(true);
        selectedAllArray.push(item);
      } else {
        item.isSelected = false;
        setIsAnySchedulesSelected(false);
        selectedAllArray.push(item);
      }
    });
    setSelectScheduleListData(selectedAllArray);
  };

  const addFinalscheduleListData = () => {
    const selectedArray: any = [];
    props.listData.map((listItem: any) => {
      if (listItem.isSelected) {
        selectedArray.push(listItem);
      }
    });
    return selectedArray;
  };

  const getFinalOwnGroupIds = (finalList: any) => {
    const ownGroupIds: any = [];
    finalList.map((listItem: any) => {
      initialOwnGroup.forEach((selectedItem: any) => {
        if (selectedItem.id === listItem.id && listItem.type === "OWN") {
          ownGroupIds.push(selectedItem.id);
        }
      });
    });
    return ownGroupIds;
  };

  const getFinalAddedGroupIds = (finalList: any) => {
    const addedGroupIds: any = [];
    finalList.forEach((selectedItem: any) => {
      if (selectedItem.type !== "OWN") {
        addedGroupIds.push(selectedItem.id);
      }
    });
    return addedGroupIds;
  };

  const onCheckboxClicked = (isChecked: boolean, checkedItem: any) => {
    if (isChecked) {
      checkedItem.isSelected = true;
      setIsAnySchedulesSelected(true);
    } else {
      checkedItem.isSelected = false;
    }
    const selectedSitesList: Array<any> = [];
    toggleSubmitButton();
  };

  const paramsAdd = {
    page: 1,
    reg_code: utilService.getNetwork(),
  };

  const getSubmitParams = (finalList: any) => {
    return {
      added_groups: getFinalAddedGroupIds(finalList),
      own_groups: getFinalOwnGroupIds(finalList),
      reg_code: utilService.getNetwork(),
    };
  };

  const paramsSelect = {
    list_all: true,
    guid: utilService.getLoggedUserGuid(),
    reg_code: utilService.getNetwork(),
  };
  const onCancelClick = () => {
    const selectedAllArray: any = [];
    props.listData.map((item: any) => {
      if (
        finalList.filter(
          (selectedItem: any) =>
            selectedItem.dataId === item.dataId && selectedItem.isSelected
        ).length > 0
      ) {
        item.isSelected = true;
      } else {
        setIsAllSchedulesSelected(false);
        item.isSelected = false;
      }
    });
    props.onCancel();
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="add-schedule-model modal-popup-wrapper-nurse-site"
      // onDidDismiss={() => props.onOk(selectScheduleListData)}
    >
      <IonItem>
        <IonLabel className="schedule">Sites</IonLabel>
      </IonItem>
      <IonGrid className="scrollbar">
        <IonRow>
          <IonCol>
            <IonList className="items">
              {props.listData.length > 0 ? (
                <div>
                  <IonItem lines="none">
                    <div>
                      <IonCheckbox
                        className="check-box"
                        color="success"
                        id="select-all-checkbox"
                        slot="start"
                        checked={isAllSchedulesSelected}
                        onClick={(e) =>
                          selectOrUnselectAllSchedules(
                            e.currentTarget.checked,
                            selectScheduleListData
                          )
                        }
                      />
                    </div>
                    <IonLabel className="site-name">All</IonLabel>
                  </IonItem>
                </div>
              ) : null}
              {props.listData && props.listData.length > 0 ? (
                props.listData.map((item: any, index: number) => {
                  return [
                    <div className="schedule-item-container">
                      <div className="schedule-checkbox-div">
                        <IonItem lines="none" key={index}>
                          <div>
                            <IonCheckbox
                              className="check-box"
                              color="success"
                              slot="start"
                              onIonChange={(e) =>
                                onCheckboxClicked(e.detail.checked, item)
                              }
                              checked={item.isSelected}
                              value={item.dataName}
                            />
                          </div>
                          <IonLabel className="site-name">
                            {item.dataName}
                          </IonLabel>
                        </IonItem>
                      </div>
                    </div>,
                  ];
                })
              ) : (
                <div className="no-results-label">{t("noSites")}</div>
              )}
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
      <div className="buttons-container-div">
        <IonButton
          color="medium"
          className="cancel-button button secondary-btn btn-curved"
          onClick={onCancelClick}
        >
          {t("cancel")}
        </IonButton>
        <IonButton
          // disabled={!isAnySchedulesSelected}
          className="submit-btn button primary-btn btn-curved"
          onClick={() => onSubmit()}
        >
          {t("ok")}
        </IonButton>
      </div>
    </IonModal>
  );
};

export default SelectSite;
